
import Menu from '@/components/menu/menu.vue'
import Vue from 'vue'
import { Form } from 'element-ui'
import { getHotelList } from '@/api/hotel'
import {
	getOrderList,
	getOrderListFailed,
	putOrderListFailed,
	putOrderList,
	cancleOrderList,
	getRoomAvailList,
	putOrderListAgain,
	postOrderList,
	deleteOrderList,
} from '@/api/ota'
import { export_json_to_excel } from '@/vendor/Export2Excel'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
dayjs.extend(isToday)
export default Vue.extend({
	components: {
		Menu,
	},
	data() {
		return {
			dayjs,
			showInfo1: true,
			showInfo2: true,
			hotel_name: '',
			pms_hotel_id: '',
			total: 0,
			searchForm: {
				guest_name: '', // 客人姓名
				order_code: '', // 订单号
				stay_date: [] as Array<string>, //入住和离店日期查询
				pms_hotel_code: '', // PMS酒店编码
				pms_hotel_id: '', // PMS酒店id
				action: '',
				result: '',
			},
			orderStauts: '3',
			table_data: [],
			table_state: {
				loading: false,
			},
			orderStatusList: [
				{
					name: '已处理订单',
					value: '3',
					disabled: false,
					id: '1',
				},
				{
					name: '未处理订单',
					value: '1',
					disabled: false,
					id: '2',
				},
				// {
				// 	name: '失败订单',
				// 	value: '2',
				// 	disabled: false,
				// },
			],
			orderResultList: [
				{
					name: '下单',
					id: 'book',
				},
				{
					name: '取消',
					id: 'cancel',
				},
				{
					name: '修改',
					id: 'modify',
				},
			],
			orderTypeList: [
				{
					name: '成功',
					id: 'suc',
				},
				{
					name: '失败',
					id: 'fail',
				},
			],
			hotels: [] as any,
			limit: 10,
			page: 1,
			src_channel: '携程',
			addFormVisible: false,
			roomAvailList: [],
			addForm: {
				HotelName: '' as any,
				VouchId: '' as any,
				Contact: '' as any,
				RoomCount: 1 as any,
				RoomDate: '' as any,
				Comments: '' as any,
				RoomType: '' as any,
				HotelCode: '' as any,
				PmsHotelId: '' as any,
				complex: '' as any,
				request_qty: 1,
			},
			addRoomForm: {
				NightInfo: [],
			},
			addFormRules: {
				HotelName: [{ required: true, message: '请选择酒店名称', trigger: 'blur' }],
				VouchId: [{ required: true, message: '请输入订单号', trigger: 'blur' }],
				Contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
				RoomCount: [{ required: true, message: '请输入间数', trigger: 'blur' }],
				RoomDate: [{ required: true, message: '请选择入住时间', trigger: 'blur' }],
				Comments: [{ required: true, message: '请输入备注', trigger: 'blur' }],
				RoomType: [{ required: true, message: '请选择房型', trigger: 'blur' }],
			},
			roomTypeHolder: '请选择房型',
			originDate: null,
			title: '新增',
		}
	},
	computed: {
		topMenuList() {
			const param = [
				{
					name: '携程订单',
					value: '1',
					info: '携程',
					disabled: false,
					id: '1',
				},
				{
					name: '美团订单',
					value: '3',
					info: '美团',
					disabled: false,
					id: '2',
				},
				{
					name: '马蜂窝订单',
					value: '2',
					info: '马蜂窝',
					id: '4',
				},
				{
					name: '同城订单',
					value: '待定',
					info: '马蜂窝',
					disabled: true,
					id: '3',
				},
				{
					name: '飞猪订单',
					value: '4',
					info: '飞猪',
					disabled: true,
					id: '5',
				},
				{
					name: '驴妈妈订单',
					value: '驴妈妈',
					info: '5',
					disabled: true,
					id: '6',
				},
				{
					name: '途牛订单',
					value: '6',
					info: '途牛',
					disabled: true,
					id: '7',
				},
			]
			if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
				return param
			} else {
				return param.slice(0, 1)
			}
		},
	},
	created() {
		getHotelList().then((res) => {
			if (res.code == 0) {
				this.hotels = res.data.rows
				this.searchForm.pms_hotel_id = this.hotels[0].id
				this.searchForm.pms_hotel_code = this.hotels[0].miccode
				this.hotel_name = this.hotels[0].name
				this.pms_hotel_id = this.hotels[0].id
				this.getXcpmsOrderSuccess()
			}
		})
	},
	watch: {
		'addForm.RoomDate': {
			handler(val) {
				this.addForm.RoomDate = val
				if (val && val.length && val[0] && val[1]) {
					if ((this.originDate as any) && (this.originDate as any).Stays && (this.originDate as any).Stays.length) {
						this.addRoomForm.NightInfo = (this.originDate as any).Stays[0].RoomRates.map((item, index) => {
							return {
								date: item.StartDate,
								price: item.AmountAfterTax,
								count:
									(this.originDate as any).Stays[0].Request && (this.originDate as any).Stays[0].Request[index]
										? (this.originDate as any).Stays[0].Request[index].Quantity || 0
										: 0,
							}
						})
					} else {
						const daysList = this.enumerateDaysBetweenDates(val[0], val[1])
						this.addRoomForm.NightInfo = (daysList as any).map((item) => {
							return {
								price: '',
								count: '0',
								date: item,
							}
						})
					}
					this.getRoomAvailList(dayjs(val[0]).format('YYYY-MM-DD'), dayjs(val[1]).format('YYYY-MM-DD'))
				} else {
					this.addRoomForm.NightInfo = []
				}
			},
			immediate: true,
			deep: true,
		},
		'addForm.RoomCount'(val) {
			this.addForm.RoomCount = val
			let date = this.addForm.RoomDate
			if (val && val.length) {
				this.addForm.RoomType = ''
				this.getRoomAvailList(dayjs(date[0]).format('YYYY-MM-DD'), dayjs(date[1]).format('YYYY-MM-DD'))
			}
		},
	},
	methods: {
		computedName(val) {
			if (!val) return ''
			let res = JSON.parse(val.replace(/\n|\r/g, ''))
			return (res.Stays && res.Stays.length && res.Stays[0].RoomType) || ''
		},
		changeHotelName(e) {
			const res = this.hotels.find((item) => {
				return item.id == e
			})
			this.addForm.HotelName = res.name
			this.addForm.HotelCode = res.miccode
			this.addForm.PmsHotelId = res.id
			this.addForm.complex = res.complex
			this.addForm.request_qty = res.request_qty || 1
			this.addForm.RoomCount = res.request_qty || 1
			let val = this.addForm.RoomDate
			if (val && val.length) {
				this.addForm.RoomType = ''
				this.getRoomAvailList(dayjs(val[0]).format('YYYY-MM-DD'), dayjs(val[1]).format('YYYY-MM-DD'))
			}
		},
		enumerateDaysBetweenDates(startDate: any, endDate: any) {
			let daysList = []
			let SDate = dayjs(startDate) as any
			let EDate = dayjs(endDate) as any
			;(daysList as any).push(SDate.format('YYYY-MM-DD'))
			while (SDate.add(1, 'days').isBefore(EDate)) {
				SDate = SDate.add(1, 'days')
				;(daysList as any).push(SDate.format('YYYY-MM-DD'))
			}
			return daysList
		},
		changeSearchInfo() {
			this.changeStatusTabTop({ value: this.orderStauts })
		},
		changehotels(e) {
			let find = this.hotels.find((item) => {
				return item.id == e
			})
			if (find) {
				this.hotel_name = find.name
				this.searchForm.pms_hotel_code = find.miccode
			}
			this.changeStatusTabTop({ value: this.orderStauts })
		},
		changeOrderResult() {
			if (this.searchForm.action && this.searchForm.result === '') {
				this.searchForm.result = this.orderTypeList[0].id
			}
		},
		changeOrderType() {
			if (this.searchForm.result && this.searchForm.action === '') {
				this.searchForm.action = this.orderResultList[0].id
			}
		},
		searchFormMethods() {
			this.page = 1
			this.changeStatusTab({ value: this.orderStauts })
		},
		addFormMethods() {
			this.addFormVisible = true
		},
		getRoomAvailList(start_date, end_date) {
			getRoomAvailList({
				pms_hotel_code: this.addForm.HotelCode,
				start_date,
				end_date,
				complex: this.addForm.complex,
				request_qty: this.addForm.RoomCount || this.addForm.request_qty,
			}).then((res) => {
				this.roomAvailList = res.data as any
			})
		},
		inputPrice(val, index, attr) {
			const cleanedValue = val.replace(/[^0-9.]/g, '')
			;(this.addRoomForm.NightInfo as any)[index][attr] = cleanedValue
		},
		formatPrice(val, index, attr) {
			if (!val) return
			const parts: any = val.split('.')
			if (parts.length > 1) {
				parts[1] = parts[1].length >= 2 ? parts[1].slice(0, 2) : parts[1] + '0'
			} else {
				parts[1] = '00'
			}
			;(this.addRoomForm.NightInfo as any)[index][attr] = parts.join('.')
		},
		closeHotelDialog() {
			this.title = '新增'
			;(this.$refs.addFormRef as Form).resetFields()
			;(this.$refs.addRoomFormRef as Form) && (this.$refs.addRoomFormRef as Form).resetFields()
			this.originDate = null
			this.addForm.HotelName = ''
			this.addForm.VouchId = ''
			this.addForm.Contact = ''
			this.addForm.RoomCount = 1
			this.addForm.RoomDate = ''
			this.addForm.Comments = ''
			this.addForm.RoomType = ''
			this.addForm.HotelCode = ''
			this.addForm.complex = ''
			this.addForm.request_qty = '' as any
			this.addRoomForm.NightInfo = []
			this.addFormVisible = false
		},
		addFormSubmit() {
			if (this.originDate) {
				putOrderListAgain({
					VouchId: this.addForm.VouchId,
					RoomType: this.addForm.RoomType,
					SrcChannel: this.src_channel,
				}).then((res) => {
					if (res.code == 0) {
						this.$message.success('重新下单成功')
						this.closeHotelDialog()
						this.changeStatusTab({ value: this.orderStauts })
					}
				})
			} else {
				const flag = this.addRoomForm.NightInfo.some((item) => !(item as any).price)
				if (flag) {
					this.$message.error('请填写价格')
					return false
				}
				let info: any = this.addRoomForm.NightInfo
				const NightInfo = info.map((item) => {
					const { price, count, date } = item
					return [dayjs(date).format('YYYY-MM-DD'), +price, +count]
				})
				;(this.$refs.addFormRef as Form).validate((valid) => {
					if (valid) {
						postOrderList({
							HotelName: this.addForm.HotelName,
							VouchId: this.addForm.VouchId,
							Contact: this.addForm.Contact,
							RoomCount: this.addForm.RoomCount,
							Comments: this.addForm.Comments,
							RoomType: this.addForm.RoomType,
							HotelCode: this.addForm.HotelCode,
							PmsHotelId: this.addForm.PmsHotelId,
							NightInfo: JSON.stringify(NightInfo),
							SrcChannel: this.src_channel,
						}).then((res) => {
							if (res.code == 0) {
								this.$message.success('新增订单成功')
								this.closeHotelDialog()
								this.changeStatusTab({ value: this.orderStauts })
							}
						})
					}
				})
			}
		},
		tryOrder(row) {
			const res = JSON.parse(row.request_params.replace(/\n|\r/g, ''))
			this.originDate = res
			this.title = row.request_result_data
			console.log(row, res)

			if (!res.Stays[0].RoomType) {
				this.roomTypeHolder = row.sale_room_type
			}
			this.addForm.HotelName = row.hotel_name
			this.changeHotelName(row.pms_hotel_id)
			this.addForm.HotelCode = res.HotelCode
			this.addForm.VouchId = res.VouchId
			this.addForm.RoomCount = res.RoomCount
			this.addForm.Contact = res.Contact
			this.addForm.RoomDate = [new Date(res.Stays[0].ArrDate), new Date(res.Stays[0].DepDate)]
			this.addForm.RoomType = res.Stays[0].RoomType
			this.addFormVisible = true
		},
		cancleOrder(row) {
			const res = JSON.parse(row.request_params.replace(/\n|\r/g, ''))
			this.$confirm(`确定对订单编号为${row.order_code}进行取消操作吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					deleteOrderList({
						VouchId: res.VouchId,
						SrcChannel: this.src_channel,
					}).then((res) => {
						if (res.code == 0) {
							this.$message.success('取消订单成功')
							this.changeStatusTab({ value: this.orderStauts })
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作',
					})
				})
		},
		changeLimit(data) {
			this.page = 1
			this.limit = data
			// 1未处理 2失败 3成功
			if (this.orderStauts == '1') {
				this.getXcpmsOrder()
			} else if (this.orderStauts == '2') {
				this.getOrderfailed()
			} else if (this.orderStauts == '3') {
				this.getXcpmsOrderSuccess()
			}
		},
		changePages(data) {
			this.page = data
			this.changeStatusTab({ value: this.orderStauts })
		},
		changeDate() {
			if (this.searchForm.stay_date == null) {
				this.searchForm.stay_date = []
			}
			this.changeStatusTabTop({ value: this.orderStauts })
		},
		// 获取当前酒店的未处理订单
		getXcpmsOrder() {
			let my_stay_date = this.searchForm.stay_date == null ? [] : this.searchForm.stay_date.join('-')
			this.table_state.loading = true
			getOrderList({
				...this.searchForm,
				stay_date: my_stay_date,
				page: this.page,
				limit: this.limit,
				manual_result: 1,
				src_channel: this.src_channel,
			})
				.then((res) => {
					if (res.code == 0) {
						this.total = res.count
						let data: any = res.data.map((item) => {
							// let splitInfo = item.request_result.split(':')
							// const regex = /'([^']*)'/
							// const matches = splitInfo[3].match(regex)
							return {
								...item,
								// request_result: matches[1],
							}
						})
						this.table_data = data
					}
				})
				.finally(() => {
					this.table_state.loading = false
				})
		},
		getXcpmsOrderSuccess() {
			let my_stay_date = this.searchForm.stay_date == null ? [] : this.searchForm.stay_date.join('-')
			this.table_state.loading = true
			getOrderList({
				...this.searchForm,
				stay_date: my_stay_date,
				page: this.page,
				limit: this.limit,
				manual_result: '',
				src_channel: this.src_channel,
			})
				.then((res) => {
					if (res.code == 0) {
						this.total = res.count
						let data: any = res.data.map((item) => {
							// let splitInfo = item.request_result.split(':')
							// const regex = /'([^']*)'/
							// const matches = splitInfo[3].match(regex)
							return {
								...item,
								// request_result: matches[1],
							}
						})
						this.table_data = data
					}
				})
				.finally(() => {
					this.table_state.loading = false
				})
		},
		getOrderfailed() {
			this.table_state.loading = true
			let my_stay_date = this.searchForm.stay_date == null ? [] : this.searchForm.stay_date.join('-')
			getOrderListFailed({
				...this.searchForm,
				stay_date: my_stay_date,
				page: this.page,
				limit: this.limit,
				src_channel: this.src_channel,
			})
				.then((res) => {
					if (res.code == 0) {
						this.total = res.count
						let data: any = res.data.map((item) => {
							// let splitInfo = item.failed_reason.split(':')
							// const regex = /'([^']*)'/
							// const matches = splitInfo[3].match(regex))
							return {
								...item,
								// failed_reason: matches[1],
							}
						})
						this.table_data = data
					}
				})
				.finally(() => {
					this.table_state.loading = false
				})
		},
		changeStatusTabTop(e) {
			this.page = 1
			this.orderStauts = e.value
			this.changeStatusTab({ value: this.orderStauts })
		},
		changeStatusTab(e) {
			this.orderStauts = e.value
			// 1未处理 2失败 3成功
			if (this.orderStauts == '1') {
				this.getXcpmsOrder()
			} else if (this.orderStauts == '2') {
				this.getOrderfailed()
			} else if (this.orderStauts == '3') {
				this.getXcpmsOrderSuccess()
			}
		},
		// 取消订单 功能已经取消 后面确定会删除
		cancelOrder(row) {
			this.$confirm(
				`<span style="font-size: 24px; text-align: center;"><i class="el-icon-warning" style="color: #E6A23C;"></i></span ><span style="line-height: 15px;">确定对订单号为${row.order_code}进行取消操作吗？</span>`,
				{
					distinguishCancelAndClose: true,
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}
			)
				.then(() => {
					cancleOrderList({
						order_code: row.order_code,
						pms_hotel_code: this.searchForm.pms_hotel_code,
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '操作成功',
							})
							let findItem: any = this.table_data.findIndex((item: any) => {
								return item.id == row.id
							})
							if (findItem !== -1) {
								this.$set(this.table_data[findItem], 'manual_result', 4)
							}
							// this.changeStatusTab({ value: this.orderStauts })
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消操作',
					})
				})
		},
		overEnter(row) {
			this.$confirm(`确定此条数据完成录入？`, {
				distinguishCancelAndClose: true,
				dangerouslyUseHTMLString: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			})
				.then(() => {
					putOrderList({
						id: row.id,
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'info',
								message: '操作成功',
							})
							this.changeStatusTab({ value: this.orderStauts })
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消操作',
					})
				})
		},
		tryNext(row) {
			//<i class="el-icon-warning" style="color:red; font-size: 24px; "></i>
			this.$confirm(
				`<span style="font-size: 24px; text-align: center;"><i class="el-icon-warning" style="color: #E6A23C;"></i></span>确认错误已修正后，重新尝试，RPA将再次向PMS推送数据？`,
				{
					distinguishCancelAndClose: true,
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}
			)
				.then(() => {
					putOrderList({
						id: Number(row.id),
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'info',
								message: '操作成功',
							})
							this.changeStatusTab({ value: this.orderStauts })
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消操作',
					})
				})
		},
		// 切换 订单类型
		changeChannelTab(data) {
			this.src_channel = data.info
			this.changeStatusTabTop({ value: this.orderStauts })
		},
		// 导出
		async que() {
			let Listresult
			this.orderStauts
			let my_stay_date = this.searchForm.stay_date == null ? [] : this.searchForm.stay_date.join('-')
			let queSearchForm = {
				...this.searchForm,
				stay_date: my_stay_date,
				page: this.page,
				limit: this.limit,
				export: '1',
				src_channel: this.src_channel,
			}
			let tHeader: Array<string> = ['序号', '订单号', '酒店名称', '客人姓名', '房型名称', '住宿时间'] //将对应的属性名转换成中文
			let tHeaderValue: Array<string> = ['id', 'order_code', 'hotel_name', 'guest_name', 'sale_room_type', 'stay_date'] //table表格中对应的属性名
			let tTitle = ''
			// 1未处理 2失败 3成功
			if (this.orderStauts == '1') {
				Listresult = await getOrderList({
					...queSearchForm,
					manual_result: 1,
				})
				tHeader = [...tHeader, '订单类型']
				tHeaderValue = [...tHeaderValue, 'request_result']
				tTitle = this.hotel_name + this.src_channel + '未处理订单'
			} else if (this.orderStauts == '2') {
				Listresult = await getOrderListFailed({
					...queSearchForm,
				})
				tHeader = [...tHeader, '失败原因']
				tHeaderValue = [...tHeaderValue, 'failed_reason']
				tTitle = this.hotel_name + this.src_channel + '失败订单'
			} else if (this.orderStauts == '3') {
				Listresult = await getOrderList({
					...queSearchForm,
					request_result: 1,
				})
				Listresult.data.map((item: any) => {
					;(item.request_result = item.request_result == 1 ? '成功' : item.request_result),
						(item.cancel_result = item.cancel_result == 1 ? '成功' : item.cancel_result),
						(item.modify_result = item.modify_result == 1 ? '成功' : item.modify_result)
				})
				tHeader = [...tHeader, '下单结果', '取消结果', '修改结果']
				tHeaderValue = [...tHeaderValue, 'request_result', 'cancel_result', 'modify_result']
				tTitle = this.hotel_name + this.src_channel + '成功订单'
			}
			let dataresult = Listresult.data
			//兼容ie10哦！导出功能
			require.ensure([], () => {
				const data = this.formatJson(tHeaderValue, dataresult)
				export_json_to_excel(tHeader, data, tTitle)
			})
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) => filterVal.map((j) => v[j]))
		},
	},
})
